import React from "react";
import {
  Avatar,
  Box,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";

import { useLoginStore } from "../../../LoginModule/store";
import { UserRoleDisplayText } from "../../../../shared/interfaces";

/**
 * Компонент профиля пользователя в заголовке.
 *
 * - Показывает аватар и имя пользователя.
 * - При нажатии открывает меню с информацией о пользователе и кнопкой выхода.
 * - Использует `useLoginStore` для получения данных пользователя и выхода из системы.
 *
 * @returns React-компонент профиля пользователя в шапке.
 */
export const HeaderProfile = () => {
  const logout = useLoginStore((state) => state.logout);
  const username = useLoginStore((state) => state.username);
  const role = useLoginStore((state) => state.role);

  /** Состояние для открытия/закрытия меню пользователя */
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null,
  );

  /**
   * Открывает меню пользователя.
   * @param {React.MouseEvent<HTMLElement>} event Событие клика по аватару.
   */
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  /** Закрывает меню пользователя. */
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  /** Выполняет выход пользователя и закрывает меню. */
  const handleClickLogoutButton = () => {
    logout();
    setAnchorElUser(null);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            alt={username || "User"}
            src="/static/images/avatar/1.jpg"
            sx={{ backgroundColor: "customColors.accent" }}
          />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <Box sx={{ p: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
          <Typography component="p" variant="body1">
            {username || "Неизвестный пользователь"}{" "}
          </Typography>
          <Chip
            label={role ? UserRoleDisplayText[role] : ""}
            color="primary"
            size="small"
          />
        </Box>
        <MenuItem onClick={handleClickLogoutButton}>
          <Typography sx={{ textAlign: "center" }}>Выйти</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};
